export default __webpack_public_path__ + "locales/uk-UA/VersionHistory.json?hash=61985faba51a048c565216305c01aae2";